



































helpers = require('../../helpers.coffee')

view_model =
  components:
    listItem: require('./list_item.vue')

  data: ->
    companies: []
    loading: false
    next_page: 1
    text_field_filter: ''

  methods:
    loadCompanies: ->
      return if @loading || !@next_page
      @loading = true
      new CompaniesResource().index(@loadCompaniesSuccess, @unknownError, params: { q: { search_query: @text_field_filter }, page: @next_page})

    loadCompaniesSuccess: (data) ->
      @loading = false
      @companies = @companies.concat(data.companies)
      @next_page = data.meta.next_page

    companyUpdated: (company) ->
      @companies.replaceById(company)
      if company.email_domain_verified
        alertify.success(this.$t('general.feedback.domainVerified'))
      else
        alertify.log(this.$t('companies.feedback.domainWarning'), 'warning')

    filter: ->
      @next_page = 1
      @companies = []
      @loadCompanies()

    nameLetters: (name) ->
      [firstName, lastName] = name.split(" ")
      if !!firstName && !lastName
        return firstName.charAt(0).toUpperCase()

      return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()


  created: ->
    @loadCompanies()
    @$router.push('/') if !Session.current_user.isAdmin()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/companies/index.vue